module.exports = __webpack_public_path__ + "static/media/tb-nboyette.21fb709a.jpeg";